<template>
  <div>
    <div class="account-pages"></div>
    <div class="clearfix"></div>
    <div class="wrapper-page">
      <div class="account-bg">
        <div class="card-box m-b-0">
          <div class="text-xs-center m-t-20">
            <router-link to="/session/login" class="logo">
              <i :class="keystone.config.app.icon + ' icon-c-logo'"></i>
              <span>{{ keystone.config.app.name }}</span>
            </router-link>
          </div>
          <div class="m-t-10 p-20">
            <div class="row">
              <div class="col-xs-12 text-xs-center">
                <h6 class="text-muted text-uppercase m-b-0 m-t-0">Connexion</h6>
              </div>
            </div>
            <div class="m-t-20">
              <div class="form-group row">
                <div class="col-xs-12">
                  <input v-on:keyup.enter="authenticate" class="form-control" type="text" v-model="email" placeholder="Email">
                </div>
              </div>

              <div class="form-group row">
                <div class="col-xs-12">
                  <input v-on:keyup.enter="authenticate" class="form-control" type="password" v-model="password" placeholder="Mot de passe">
                </div>
              </div>

              <div class="form-group text-center row m-t-10">
                <div class="col-xs-12">
                  <el-button type="primary" class="btn-block waves-effect waves-light" v-on:click="authenticate" :loading="loading">Connexion</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'login',
    data () {
      return {
        email: '',
        password: '',
        loading: false
      }
    },
    methods: {
      authenticate () {
        let self = this

        this.loading = true
        this.$nexus.login(this.email, this.password).then(token => {
          let users = self.$store.dispatch('users/loadAll')
          let current = self.$store.dispatch('users/loadCurrent')
          let preferences = self.$store.dispatch('user_preferences/load')

          Promise.all([users, current, preferences]).then(responses => {
            window.location.href = window.location.pathname
          })
        }).catch((err) => {
          this.$message({
            type: 'error',
            duration: 0,
            message: 'Erreur de connexion, votre email ou mot de passe est invalide : ' + err
          })
          self.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?6d8a11b2